import * as React from "react";
import { Font } from "@react-pdf/renderer";
import { IFormSectionPresentationModel } from "../../../../presenter/form/model/FormSectionPresentationModel";
import { IReferenceValue } from "../../../../model/form/ReferenceValue";
import { IFormVersion } from "../../../../model/form/FormVersion";
import DisplayFormSectionPDF from "./DisplayFormPDFSection";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";

export interface State {}

export interface Props {
  styles: any;
  formSectionList?: IFormSectionPresentationModel[];
  loading?: boolean;
  translate: any;
  getReferenceValues?: any;
  referenceValueList?: IReferenceValue[];
  isEditableForm: boolean;
  sendFormVersion?: any;
  selectedVersion?: IFormVersion;
  isPreviousForm?: boolean;
  onChangeFormLoading?: boolean;
  className?: any;
  isPortal: boolean
}

export default class DisplayFormPDF extends React.Component<Props, State> {
  render() {
    const {
      formSectionList,
      translate,
      getReferenceValues,
      referenceValueList,
      styles,
      isPortal
    } = this.props;

    const renderFormSections = (isEditable?: boolean) => {
      let formSectionRenderList: JSX.Element[] = [];
      if (formSectionList) {
        formSectionList.sort((a, b) => {
          return a.orderNumber - b.orderNumber;
        });

        formSectionList.forEach((formSection) => {
          formSectionRenderList.push(
            <DisplayFormSectionPDF
              key={formSection.id}
              formSection={formSection}
              translate={translate}
              getReferenceValues={getReferenceValues}
              referenceValueList={referenceValueList}
              isEditableForm={false}
              styles={styles}
              isPortal={isPortal}
            />
          );
        });
      }
      return formSectionRenderList;
    };

    return renderFormSections();
  }
}

Font.register({
  family: "Segoe UI",
  src: SagoeUi 
});
